import React from "react";
import { StyleSheet, Pressable } from "react-native";
import { PlaceColors } from "./PlaceColors";
import Icon from 'react-native-vector-icons/Ionicons';

export const makeIconFilterButton = (onPressIn: () => void, icon: string, isEnabled: boolean, findifyDataContext: any) => {
    return <Pressable
        onPressIn={onPressIn}
        style={[styles.button, {
            backgroundColor: isEnabled ? PlaceColors(findifyDataContext).background.get() : PlaceColors(findifyDataContext).text.get()
        }]}
    >
        <Icon name={icon} style={{ padding: 2 }} size={24} color={isEnabled ? PlaceColors(findifyDataContext).text.get() : PlaceColors(findifyDataContext).background.get()} />
    </Pressable>;
}

const styles = StyleSheet.create({
    button: {
        padding: 4,
        borderRadius: 100,
    },
}) 